export function createDirectusAssetUrl(filename: string): string;
export function createDirectusAssetUrl(filename?: string): string | undefined;

export function createDirectusAssetUrl(filename?: string) {
  if (filename === undefined) {
    return undefined;
  }

  return `${import.meta.env.VITE_SERVICE_DIRECTUS_ASSETS_URL}/${filename}`;
}
